import { createSelector } from 'reselect';
import { userAddressesSelector } from 'selectors/userAddressesSelector';

export const selectedUserAddressSelector = createSelector(
  userAddressesSelector,
  addresses => addresses.find(v => v.selected),
);
